export var APIRequestStatus;
(function (APIRequestStatus) {
    APIRequestStatus[APIRequestStatus["Idle"] = 0] = "Idle";
    APIRequestStatus[APIRequestStatus["RequestInProgress"] = 1] = "RequestInProgress";
    APIRequestStatus[APIRequestStatus["Success"] = 2] = "Success";
    APIRequestStatus[APIRequestStatus["Failure"] = 3] = "Failure";
})(APIRequestStatus || (APIRequestStatus = {}));
